import { render, staticRenderFns } from "./Oplata.vue?vue&type=template&id=f5699dda&scoped=true"
import script from "./Oplata.vue?vue&type=script&lang=js"
export * from "./Oplata.vue?vue&type=script&lang=js"
import style0 from "./Oplata.vue?vue&type=style&index=0&id=f5699dda&prod&lang=css"
import style1 from "./Oplata.vue?vue&type=style&index=1&id=f5699dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5699dda",
  null
  
)

export default component.exports